/**
 * Einmaliger Hinweis beim ersten langen Diktat im Web auf iOS. 30.10.2026
 *
 * Safari friert eine Seite ein, sobald das Display ausgeht; die Aufnahme
 * reißt dann ab. Die App hat dieses Problem nicht. Der Hinweis erscheint
 * genau einmal (Merker im localStorage, jeder Zugriff abgesichert).
 */

/** Ab dieser Dauer gilt ein Diktat als lang. */
export const LANGES_DIKTAT_MS = 20_000;
export const IOS_DIKTAT_HINWEIS = "Bildschirm anlassen – für lange Diktate die App nutzen";
const MERKER = "vespera.iosDiktatHinweis";

/** iPhone, iPad, iPod — auch das iPad, das sich als Mac meldet. */
export function istIosWeb(ua: string, beruehrungspunkte: number): boolean {
  return /iPhone|iPad|iPod/.test(ua) || (/Macintosh/.test(ua) && beruehrungspunkte > 1);
}

export function hinweisSchonGezeigt(speicher: Pick<Storage, "getItem"> | null): boolean {
  try {
    return speicher?.getItem(MERKER) === "1";
  } catch {
    return false;
  }
}

export function merkeHinweisGezeigt(speicher: Pick<Storage, "setItem"> | null): void {
  try {
    speicher?.setItem(MERKER, "1");
  } catch {
    /* ohne Speicher erscheint er höchstens öfter */
  }
}

export interface IosHinweisLage {
  ios: boolean;
  inApp: boolean;
  dauerMs: number;
  gezeigt: boolean;
}

export function sollIosHinweisZeigen(l: IosHinweisLage): boolean {
  return l.ios && !l.inApp && !l.gezeigt && l.dauerMs >= LANGES_DIKTAT_MS;
}

/** Der Browser-Zugriff an einer Stelle: Speicher nie werfend holen. */
export function browserSpeicher(): Storage | null {
  try {
    return typeof localStorage === "undefined" ? null : localStorage;
  } catch {
    return null;
  }
}
